module.exports = __webpack_public_path__ + "static/13-dac19d556c74ba58f0a92fffedfeb3ea.jpg";